import React, { useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, A11y } from "swiper";

import { TeaserCard } from "../TeaserCard/TeaserCard";

import * as styles from "./TeaserSlider.module.less";
import GeneralPageContext from "../../../templates/GeneralPageContext";
import { useIsDesktop } from "../../../lib/hooks/mediaQueries";

export function TeaserSlider({
    idButtonNext,
    idButtonPrev,
    teaser,
    semanticOfTeaserHeadline,
    maxTeaserWidth = 308,
    TypeSpecificContent,
    hasLightBackground = true
}) {
    const isDesktop = useIsDesktop();

    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);

    const windowWidth =
        typeof window !== "undefined"
            ? window.innerWidth > 1440
                ? 1440
                : window.innerWidth
            : maxTeaserWidth;

    const slidesPerView = Math.max(windowWidth / maxTeaserWidth, 1.2);

    return (
        <Swiper
            className={styles.teaserContainer}
            modules={[Navigation, Pagination, Autoplay, A11y]}
            slidesPerView={
                showAnchorNavigation && !isDesktop ? 2 : slidesPerView
            }
            allowSlidePrev={true}
            navigation={{
                prevEl: `#${idButtonPrev}`,
                nextEl: `#${idButtonNext}`
            }}
            loop={true}
        >
            {teaser.map((teaserElement) => {
                const {
                    type,
                    teaserImage: image,
                    teaserTagline: tagline,
                    teaserHeadline: headline,
                    division,
                    teaserDocument: document,
                    teaserText: text,
                    teaserLink: link,
                    teaserUrl: url,
                    teaserButtonLabel: buttonLabel
                } = teaserElement;

                return (
                    <SwiperSlide
                        className={styles.teaserSlide}
                        key={teaserElement.id}
                    >
                        <TeaserCard
                            hasLightBackground={hasLightBackground}
                            teaserData={{
                                type,
                                image,
                                tagline,
                                headline,
                                semanticOfHeadline: semanticOfTeaserHeadline,
                                division,
                                text,
                                link,
                                url,
                                buttonLabel,
                                document
                            }}
                        >
                            {TypeSpecificContent && (
                                <TypeSpecificContent {...teaserElement} />
                            )}
                        </TeaserCard>
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
}
